import {AppLocale, locales} from '@config/locales';
import {createNavigation} from 'next-intl/navigation';
import {defineRouting} from 'next-intl/routing';
import {Link} from './Link';

const routing = defineRouting({
    locales,
    defaultLocale: AppLocale.EN,
});

const {Link: LocaleLink, useRouter, usePathname} = createNavigation(routing);

export {Link, LocaleLink, usePathname, useRouter};
